import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import ResponsiveContent from '../../../layout/ResponsiveContent';
import {Col, Row, Tabs} from 'antd';
import {capitalize} from 'lodash';
import {ImportReportTableView} from '../../../components/settings/importReport/ImportReportTableView';
import ImportReportDownload from "../../../components/settings/importReport/ImportReportDownload";
import {REPORT_DETAIL_STATUS, REPORT_STATUS} from "../../../utils/dataImport";

export default function ImportReport() {

  const {t} = useTranslation();
  const navigate = useNavigate();

  const [
    selectedView,
    setSelectedView,
  ] = useState<REPORT_DETAIL_STATUS>(REPORT_STATUS.ERROR);

  return (
    <ResponsiveContent
      title={t('dataImport.detailIssues')}
      goBack={() => navigate('/settings/import-report')}
      goBackText={t('settings.dataImport')}
      extra={<ImportReportDownload />}
    >
      <Row>
        <Col>
          <Tabs
            type={'card'}
            items={[
              {key: REPORT_STATUS.ERROR, label: capitalize(t('dataImport.error', {count: 2}))},
              {key: REPORT_STATUS.WARNING, label: capitalize(t('dataImport.warning', {count: 2}))},
              {key: REPORT_STATUS.OK, label: capitalize(t('dataImport.success'))},
            ]}
            onChange={(key) => setSelectedView(key as REPORT_DETAIL_STATUS)}
            defaultValue={'ERROR'}
          />
        </Col>
      </Row>
      <Row>
        <Col flex={1}>
          {selectedView === REPORT_STATUS.ERROR && <ImportReportTableView reportStatus={"ERROR"}/>}
          {selectedView === REPORT_STATUS.WARNING && <ImportReportTableView reportStatus={"WARNING"}/>}
          {selectedView === REPORT_STATUS.OK && <ImportReportTableView reportStatus={"OK"}/>}
        </Col>
      </Row>
    </ResponsiveContent>
  );
}